export default {
  noResultMessage: 'No result found',
  serverError: 'Sorry, there was a problem with the request.',
  networkError: 'Sorry, there seems to be a problem with your connection.',
  tryAgain: ' Please try again later.',
};
